import React, {useEffect, useState} from 'react'
import {  Form } from 'semantic-ui-react';
import { DatePicker } from '../../components/shared/DatePicker';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import NumericInput from '../../components/shared/NumericInput';
import { useMessageResources, useTextResources } from '../../language';
import GridSearchTemplate from '../GridSearchTemplate';
import CheckboxWrapper from '../../components/shared/Checkbox';
import {RMS} from '../../api/services/next'
import moment from 'moment'
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { onError, onSuccess, onWarning } from '../../components/shared/messages';
import WeekDaysSelect from '../../components/shared/WeekDaysSelect';
import { dateFormat, MenuActions } from '../../components/shared/constants';
import { useLoader } from '../../components/shared/utils';
import CheckboxToggle from '../../components/shared/CheckboxToggle'

export const RMSRulesPage = () => {
    const text = useTextResources()
    const loader = useLoader()
    const message = useMessageResources()
    const hotelId = window.optima?.user?.CurrentHotel?.Id || window.user?.CurrentHotel?.Id
    const [spec, setSpec] = useState({
        HotelId: hotelId
    })
    const dateFormatter = ({value})=>{
        return value&&moment(value).format(dateFormat)
    }
    const [data, setData] = useState([])

    const save = () => {
        (async () => {
            try {
                loader(true)
                await RMS.PostRmsRules(spec, data)             
                onSuccess()
            } catch (error) {
                onError(error)
            } finally{
                loader(false)
            }
        })()
    }

    useEffect(() => {
        if (window.optima.commands) {
          window.optima.commands.unsubscribe(MenuActions.save);
          window.optima.commands.subscribe(MenuActions.save, save);
        }
    }, [save]); 

    const weekDaysFormatter = ({row})=>{
        const weekdays = ["SelectDay_Sun", "SelectDay_Mon", "SelectDay_Tue", "SelectDay_Wed", "SelectDay_Thu", "SelectDay_Fri", "SelectDay_Sat"]
        if (row.ActiveSunday && row.ActiveMonday && row.ActiveTuesday && row.ActiveWedensday && row.ActiveThursday && row.ActiveFriday && row.ActiveSaturday) {
            return "All Week"
        } else {
            return weekdays
            .filter((x, idx)=>[row.ActiveSunday, row.ActiveMonday, row.ActiveTuesday, row.ActiveWedensday, row.ActiveThursday, row.ActiveFriday, row.ActiveSaturday][idx])
            .map(x=>text(x)).join(", ")
        }
    }
    const onUpdate = (added, changed, deleted, data) => {
        setData(data)
    }

    const validateSpec = spec=>{
        if (!spec.HotelId){
            onWarning(message("HotelsNotSelected"))
            return false
        }
        return true
    }

    const weekDaysProps = ({row})=>{
        return {
            dates: [
                {
                startDate: row.FromDate,
                endDate: row.ToDate
                }
            ],
            initDays: [0,1,2,3,4,5,6].filter(x=>[row.ActiveSunday, row.ActiveMonday, row.ActiveTuesday, row.ActiveWedensday, row.ActiveThursday, row.ActiveFriday, row.ActiveSaturday][x]),
            onChange: days=>{
                row.ActiveSunday = days.includes(0)
                row.ActiveMonday = days.includes(1)
                row.ActiveTuesday = days.includes(2)
                row.ActiveWedensday = days.includes(3)
                row.ActiveThursday = days.includes(4)
                row.ActiveFriday = days.includes(5)
                row.ActiveSaturday = days.includes(6)
            }
        }
    }


    const checkBoxFormatter = ({value})=>{
        return <CheckboxToggle readOnly checked={value}/>
    }

    const gridOptions = {
        search: {
            title: text("AutomaticYieldManagementAndDynamicPricing"),
            description: text("RMSRulesText"),
            fields: [ 
                <Form.Field control={HotelsDropDown} clearable label= {text("Hotel")} key="HotelId"/>,
                <DatePicker 
                    type="range"
                    label= {`${text("FromDate")} - ${text("ToDate")}` } 
                    name="FromToDates"
                    key="FromToDates"
                />,
                <Form.Field control={NumericInput} label= {text("NumberOfSoldRooms")} key="OccupiedRooms" digits = {0} min={0} max={100}/>,
                <Form.Field control={NumericInput} label= {text("ValueInPercent")} key="Percent" digits = {0} min={0} max={100}/>,
                <CheckboxWrapper
                    label={text("IncludeInactiveRules")} 
                    key="IncludeInActive"
                />
            ],
            initial: {HotelId: hotelId},
            api: RMS.GetRMSRules,
            validate: validateSpec,
            searchOnLoad: true
        },
        grid: {
            columns: [
                { name: 'FromDate', title: text("FromDate"),formatter: dateFormatter,  editor: <SemanticDatepicker format={dateFormat}/>, valueField: value=>moment(value).toDate()},
                { name: 'ToDate', title: text("ToDate"),formatter: dateFormatter, editor: <SemanticDatepicker format={dateFormat}/>, valueField: value=>moment(value).toDate() },
                { name: 'Weekdays', title: text("Weekdays"), formatter: weekDaysFormatter, editor: <WeekDaysSelect/>, customProps: weekDaysProps },
                { name: 'MinNumberOfOccupiedRooms', title: text("NumberOfSoldRooms"), editor: <NumericInput digits={0} min={0} max={100}/> },
                { name: 'ChangePriceByPercent', title: text("Percent"), editor: <NumericInput digits={0} min={0} max={100}/> },
                { name: 'IsActive', editor: <CheckboxToggle style={{marginTop: 8, marginBottom: 8}}/>, formatter: checkBoxFormatter, customProps: ({value}) => { return {checked: value}}}
                
            ],
            columnExtensions: [
                { columnName: 'HotelId', editingEnabled: false } 
            ],
            editable: {
                allowAdd: true,
                allowDelete: true
            }
        }
    }
    return (<GridSearchTemplate options={gridOptions} onGridUpdate={onUpdate} onSearchChange={setSpec} onSearchComplete={data=>{setData(data);return true}}/>)
}